import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import { editFormInput, getInputData } from '../store/forms';
import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import { getYears, getMonths } from '../store/models';
import Title from './Title';
import { Stack } from '@mui/system';

function WarrantyForm({ showValidation }) {
	const view = "checkin2";
  const object = "warranty";
  const titularTarjeta = useSelector(getInputData(view, object, "titularTarjeta"));
  const numeroTarjeta = useSelector(getInputData(view, object, "numeroTarjeta"));
  const mesVencimiento = useSelector(getInputData(view, object, "mesVencimiento"));
  const anoVencimiento = useSelector(getInputData(view, object, "anoVencimiento"));
  
  const dispatch = useDispatch();
  const handleChangeValue = (id, value) => {
    dispatch(editFormInput({ data: value, object, input: id, view }));
  };
  const handleChange = (id, event) => {
    // console.log(event.target.value);
    handleChangeValue(id, event.target.value);
  };
  const months = useSelector(getMonths);
  const years = useSelector(getYears);

  return (
    <Stack>
        <Title sx={{ fontSize: '16px'}}> Datos para toma de garantía (opcional) </Title>
    	<Grid container spacing={0} sx={{ height: '100%' }}>
    		<Grid item xs={12} sx={{ padding: 1 }} >
    			<InputField showValidation={showValidation} control={titularTarjeta} handleChange={(e) => handleChange("titularTarjeta", e)}  />
    		</Grid>
    		<Grid item xs={12} sx={{ padding: 1 }} >
    			<InputField showValidation={showValidation} control={numeroTarjeta} handleChange={(e) => handleChange("numeroTarjeta", e)}  />
    		</Grid>
    		<Grid item xs={6} sx={{ padding: 1 }} >
    			<SelectField showValidation={showValidation} control={mesVencimiento} handleChange={(e) => handleChange("mesVencimiento", e)} options={months}  />
    		</Grid>
    		<Grid item xs={6} sx={{ padding: 1 }} >
    			<SelectField showValidation={showValidation} control={anoVencimiento} handleChange={(e) => handleChange("anoVencimiento", e)} options={years} />
    		</Grid>

    	</Grid>
    </Stack>
  );
}

export default WarrantyForm;